import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-search-filter-date]';
const PLUGIN_NAME = 'searchFilterDate';

const log = debug('search/results-filter/search-filter-date:date');

class SearchFilterDate {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.form = this.selectors.selectTarget(
			'(parents) form',
			this.$element
		);

		this.monthSelect = this.selectors.selectTarget(
			this.options.monthSelectSelector,
			this.$element
		);

		this.yearSelect = this.selectors.selectTarget(
			this.options.yearSelectSelector,
			this.$element
		);

		this.valueInput = this.selectors.selectTarget(
			this.options.valueInputSelector,
			this.$element
		);

		this.validationMessage = this.selectors.selectTarget(
			this.options.validationMessageSelector,
			this.$element
		);

		this.watch();

		log('ready', this, this.$target);
	}

	watch() {
		log('watching');

		this.form.on('submit', this.onSubmit.bind(this));

		this.monthSelect.on('change', this.onChange.bind(this));
		this.yearSelect.on('change', this.onChange.bind(this));
	}

	hasValue(month, year) {
		const hasMonth = month !== '0';
		const hasYear = year !== '0';

		return hasMonth || hasYear;
	}

	isValid(month, year) {
		const hasMonth = month !== '0';
		const hasYear = year !== '0';

		return (hasMonth && hasYear) || (!hasMonth && !hasYear);
	}

	updateValidation(month, year) {
		const shouldDisplay = !this.isValid(month, year);
		if (shouldDisplay) {
			this.validationMessage.removeAttr('hidden');
		} else {
			this.validationMessage.attr('hidden', 'hidden');
		}
	}

	updateValue(month, year) {
		const newValue = this.hasValue(month, year)
			? `${year}${month}`
			: '';
		this.valueInput.val(newValue);
	}

	// trigger this method from parent date range
	reset() {
		this.monthSelect.val('0');
		this.yearSelect.val('0');
		this.updateValue('0', '0');
		this.updateValidation('0', '0');
	}

	onChange() {
		const monthValue = this.monthSelect.val();
		const yearValue = this.yearSelect.val();
		const isValid = this.isValid(monthValue, yearValue);

		// Don't show validation errors before submiting
		if (isValid) {
			this.updateValidation(monthValue, yearValue);
		}

		// update here to update All dates checkbox immediately
		this.updateValue(monthValue, yearValue);

		this.$element.trigger('datechange');
	}

	onSubmit(event) {
		log('submit');
		const monthValue = this.monthSelect.val();
		const yearValue = this.yearSelect.val();
		const isValid = this.isValid(monthValue, yearValue);

		// these may be redundant as they will have been called onChange?
		this.updateValidation(monthValue, yearValue);
		this.updateValue(monthValue, yearValue);

		if (!isValid) {
			event.preventDefault();
		}
	}
}

SearchFilterDate.DEFAULTS = {};

plugin(PLUGIN_NAME, SearchFilterDate);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});




// WEBPACK FOOTER //
// ./project/client/src/site__ale001/components/search/results-filter/search-filter-date.js